import { render, staticRenderFns } from "./drawer_editUserInfo.vue?vue&type=template&id=1f4b8a04&scoped=true&"
import script from "./drawer_editUserInfo.vue?vue&type=script&lang=js&"
export * from "./drawer_editUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./drawer_editUserInfo.vue?vue&type=style&index=0&id=1f4b8a04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4b8a04",
  null
  
)

export default component.exports